import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BeaconlistComponent } from './admin/beaconlist/beaconlist.component';
import { GpslistComponent } from './admin/gpslist/gpslist.component';
import { OrganizationsComponent } from './admin/organizations/organizations.component';
import { ScenarioeditComponent } from './admin/scenarioedit/scenarioedit.component';
import { ScenariohistComponent } from './admin/scenariohist/scenariohist.component';
import { ScenariolistComponent } from './admin/scenariolist/scenariolist.component';
import { SensorComponent } from './admin/sensor/sensor.component';
import { UsereditComponent } from './admin/useredit/useredit.component';
import { UserlistComponent } from './admin/userlist/userlist.component';
import { BackendtesterComponent } from './dev/backendtester/backendtester.component';
import { BasecomponenttesterComponent } from './dev/basecomponenttester/basecomponenttester.component';
import { ColorsComponent } from './dev/colors/colors.component';
import { EnvironmentComponent } from './dev/environment/environment.component';
import { FormfieldsComponent } from './dev/formfields/formfields.component';
import { KmltestComponent } from './dev/kmltest/kmltest.component';
import { RolesComponent } from './dev/roles/roles.component';
import { TodoComponent } from './dev/todo/todo.component';
import { DrawonmapComponent } from './devgps/drawonmap/drawonmap.component';
import { FollowmeComponent } from './devgps/followme/followme.component';
import { GoogleapiComponent } from './devgps/googleapi/googleapi.component';
import { GpssimplereadComponent } from './devgps/gpssimpleread/gpssimpleread.component';
import { MapclickComponent } from './devgps/mapclick/mapclick.component';
import { PolygonComponent } from './devgps/polygon/polygon.component';
import { WhereamiComponent } from './devgps/whereami/whereami.component';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { SimulationComponent } from './student/simulation/simulation.component';
import { SimdebugComponent } from './student/simdebug/simdebug.component';
import { ConfigtableComponent } from './dev/configtable/configtable.component';
import { BeaconlogComponent } from './admin/beaconlog/beaconlog.component';
import { D2Component } from './dev/d2/d2.component';
import { ModaltestComponent } from './dev/modaltest/modaltest.component';
import { RichtexttesterComponent } from './dev/richtexttester/richtexttester.component';
import { ActivitiesComponent } from './admin/activities/activities.component';
import { DbsizeComponent } from './dev/dbsize/dbsize.component';
import { ResetComponent } from './login/reset/reset.component';
import { TestresetComponent } from './login/testreset/testreset.component';
import { Scenarioedit2Component } from './admin/scenarioedit/scenarioedit2/scenarioedit2.component';
import { ScenarioedittestComponent } from './admin/scenarioedit/scenarioedittest/scenarioedittest.component';
import {ScenbeacSensConsComponent} from './admin/scenbeac-sens-cons/scenbeac-sens-cons.component';
import {FirebaseComponent} from './dev/firebase/firebase.component'
import { WorldsComponent } from './firebase/worlds/worlds.component';
import { FbscenariosComponent } from './firebase/fbscenarios/fbscenarios.component';
import { FbscenarioeditComponent } from './firebase/fbscenarios/fbscenarioedit/fbscenarioedit.component';
import { AvatarsComponent } from './firebase/avatars/avatars.component';
import { FbdocumentationComponent } from './firebase/fbdocumentation/fbdocumentation.component';
import { SurveysComponent } from './firebase/surveys/surveys.component';
import { EventsComponent } from './firebase/events/events.component';
import { AlarmsettingComponent } from './admin/alarmsetting/alarmsetting.component';
import { LessonplansComponent } from './firebase/lessonplans/lessonplans.component';
import { MeasurementsComponent } from './firebase/measurements/measurements.component';
import { RenderlogComponent } from './firebase/renderlog/renderlog.component';
import {VirtexAssetsComponent} from "./virtex/virtex-assets/virtex-assets.component";
import { ExercisesComponent } from './virtex/exercises/exercises.component';
import { ExerciseEditComponent } from './virtex/exercise-edit/exercise-edit.component';
import { VscenariosComponent } from './virtex/vscenarios/vscenarios.component';
import { VscenarioeditComponent } from './virtex/vscenarioedit/vscenarioedit.component';
import { TexturesComponent } from './virtex/textures/textures.component';
import { FbqueriesComponent } from './virtex/fbqueries/fbqueries.component';
import { PerformanceComponent } from './virtex/performance/performance.component';
import { PerformancedetailComponent } from './virtex/performancedetail/performancedetail.component';
import { ExerciseAnalysisComponent } from './virtex/performance/exerciseAnalysis/exercise-analysis.component';
import { EventmanagerComponent } from './virtex/eventmanager/eventmanager.component';
import { DocuvirtexComponent } from './virtex/docuvirtex/docuvirtex.component';
import { FBSchemaComponent } from './virtex/fbschema/fbschema.component';
import { EventclassesComponent } from './virtex/eventclasses/eventclasses.component';
import { AssetlistComponent } from './virtex/assetlist/assetlist.component';
import { InteractivityMatrixComponent } from './virtex/interactivity-matrix/interactivity-matrix.component';
import { ModifierMatrixComponent } from './virtex/modifier-matrix/modifier-matrix.component';

const routes: Routes = [
  // student ----------------------------------------------------
  { path: 'simulation', component: SimulationComponent },
  { path: 'simdebug', component: SimdebugComponent },

  // admin ----------------------------------------------------
  { path: 'organizations', component: OrganizationsComponent },
  { path: 'beacons', component: BeaconlistComponent },
  { path: 'scenarios', component: ScenariolistComponent },
  { path: 'scenario', component: ScenarioeditComponent },
  { path: 'gpslogs', component: GpslistComponent },
  { path: 'beaconlogs', component: BeaconlogComponent },
  { path: 'userlist', component: UserlistComponent },
  { path: 'useredit', component: UsereditComponent },
  { path: 'sensor', component: SensorComponent },
  { path: 'scenariohist', component: ScenariohistComponent },
  { path: 'activities', component: ActivitiesComponent },
  { path: 'scenbeacsenscons', component: ScenbeacSensConsComponent },
  { path: 'alarmsettings', component: AlarmsettingComponent },

  // development ---------------------------------
  { path: 'colors', component: ColorsComponent },
  { path: 'environment', component: EnvironmentComponent },
  { path: 'formfields', component: FormfieldsComponent },
  { path: 'basecomponenttester', component: BasecomponenttesterComponent },
  { path: 'home', component: HomeComponent },
  { path: 'roles', component: RolesComponent },
  { path: 'backendtester', component: BackendtesterComponent },
  { path: 'kmltest', component: KmltestComponent },
  { path: 'todo', component: TodoComponent },
  { path: 'configtable', component: ConfigtableComponent },
  { path: 'd3', component: D2Component },
  { path: 'modaltest', component: ModaltestComponent },
  { path: 'richtexttester', component: RichtexttesterComponent },
  { path: 'dbsize', component: DbsizeComponent },
  { path: 'testreset', component: TestresetComponent },
  { path: 'scenarioedit2', component: Scenarioedit2Component },
  { path: 'scenarioedittest', component: ScenarioedittestComponent },
  { path: 'firebase', component: FirebaseComponent },


  // firebase componens
  { path: 'fbdocumentation', component: FbdocumentationComponent },
  { path: 'worlds', component: WorldsComponent },
  { path: 'fbscenarios', component: FbscenariosComponent },
  { path: 'fbscenarioedit', component: FbscenarioeditComponent },
  { path: 'avatars', component: AvatarsComponent },
  { path: 'surveys', component: SurveysComponent },
  { path: 'events', component: EventsComponent },
  { path: 'lessonplans', component: LessonplansComponent },
  { path: 'measurements', component: MeasurementsComponent },
  { path: 'renderlog', component: RenderlogComponent },

  // virtex
  { path: 'docuvirtex', component: DocuvirtexComponent },
  { path: 'exercises', component: ExercisesComponent },
  { path: 'exerciseedit', component: ExerciseEditComponent },
  { path: 'vscenarios', component: VscenariosComponent },
  { path: 'interactivitymatrix', component: InteractivityMatrixComponent },
  { path: 'modifiermatrix', component: ModifierMatrixComponent },
  { path: 'vscenarioedit', component: VscenarioeditComponent },
  { path: 'eventmanager', component: EventmanagerComponent },
  { path: 'virtex-assets', component: VirtexAssetsComponent },
  { path: 'textures', component: TexturesComponent },
  { path: 'assetlist', component: AssetlistComponent },
  { path: 'fbqueries', component: FbqueriesComponent },
  { path: 'fbschema', component: FBSchemaComponent },
  { path: 'eventclasses', component: EventclassesComponent },
  { path: 'performance', component: PerformanceComponent },
  { path: 'performancedetail', component: PerformancedetailComponent },
  { path: 'exerciseanalysis', component: ExerciseAnalysisComponent },

  // dev gps-------------------------------------
  { path: 'googleapi', component: GoogleapiComponent },
  { path: 'gpssimpleread', component: GpssimplereadComponent },
  { path: 'whereami', component: WhereamiComponent },
  { path: 'mapclick', component: MapclickComponent },
  { path: 'drawonmap', component: DrawonmapComponent },
  { path: 'polygon', component: PolygonComponent },
  { path: 'followme', component: FollowmeComponent },

  // dev login --------------------------------------
  { path: 'login', component: LoginComponent },
  { path: 'reset', component: ResetComponent },
  { path: '**', component: LoginComponent }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
